import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeRegistrationComponent } from './admin/employee-registration/employee-registration.component';
import { EmployeeListComponent } from './admin/employee-list/employee-list.component';
import { PatientListComponent } from './admin/patient-list/patient-list.component';
import { EmployeeProfileComponent } from './admin/employee-profile/employee-profile.component';
import { PaymentresponseComponent } from './paymentresponse/paymentresponse.component';
import { StaffRegistrationComponent } from './admin/staff-registration/staff-registration.component';
import { HomeComponent } from './home/home.component';
import { PatientComponent } from './patient/patient.component';
import { DoctorComponent } from './doctor/doctor.component';
import { BusinessComponent } from './business/business.component';
import { PharmacyComponent } from './pharmacy/pharmacy.component';
import { PartnerComponent } from './partner/partner.component';
import { LoginComponent } from './login/login.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { StaffListComponent } from './admin/staff-list/staff-list.component';
import { StaffProfileComponent } from './admin/staff-profile/staff-profile.component';
import { EmployeeSlotsComponent } from './admin/employee-slots/employee-slots.component';
import { DeshboardComponent } from './admin/deshboard/deshboard.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { EditEmployeeComponent } from './admin/edit-employee/edit-employee.component';
import { EditStaffComponent } from './admin/edit-staff/edit-staff.component';
import { CouponComponent } from './admin/coupon/coupon.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { UserCouponsComponent } from './admin/user-coupons/user-coupons.component'
import { FirstavailableDoctorsComponent } from './admin/firstavailable-doctors/firstavailable-doctors.component'
import { RoleAccessibilityComponent } from './admin/role-accessibility/role-accessibility.component';
import { DeeplinkComponent } from './deeplink/deeplink.component';
import { CorporatePartnerComponent } from './admin/corporate-partner/corporate-partner.component'
import { LaboratoryTestComponent } from './admin/laboratory-test/laboratory-test.component'
import { PartnerProductComponent } from './admin/partner-product/partner-product.component';
import { PartnerDashboardComponent } from './partnerUI/partner-dashboard/partner-dashboard.component';
import { PartnerOrdersComponent } from './partnerUI/partner-orders/partner-orders.component';
import { PartnerManageProductComponent } from './partnerUI/partner-manage-product/partner-manage-product.component';
import { PartnerLoginComponent } from './partnerUI/partner-login/partner-login.component';
import { UserFaqComponent } from './user-faq/user-faq.component';
import { GenerateReportComponent } from './admin/generate-report/generate-report.component';
import { AddFirebaseMessagesComponent } from './admin/add-firebase-messages/add-firebase-messages.component';
import { AssginMessagesComponent } from './admin/assgin-messages/assgin-messages.component';
import { ApiResponseComponent } from './api-response/api-response.component';
import { AssignSubscriptionComponent } from './admin/assign-subscription/assign-subscription.component';
import { AddSubscriptionComponent } from './admin/add-subscription/add-subscription.component';
import { BookAppointmentComponent } from './admin/book-appointment/book-appointment.component';
import { SubscriptionComponent } from './admin/subscription/subscription.component';
import { EditsubscriptionComponent } from './admin/editsubscription/editsubscription.component';
import { SubscriptionProductComponent } from './admin/subscription-product/subscription-product.component';
import { ImportCouponComponent } from './admin/import-coupon/import-coupon.component';
import { UploadedOrderComponent } from './admin/uploaded-order/uploaded-order.component';
import { AdminAuthGuard, PartnerAuthGuard } from './services/auth.guard';



const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: LoginComponent },
  { path: 'register', component: EmployeeRegistrationComponent, canActivate: [AdminAuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'pharmacy', component: PharmacyComponent },
  { path: 'employeeList', component: EmployeeListComponent, canActivate: [AdminAuthGuard] },
  { path: 'patientList', component: PatientListComponent, canActivate: [AdminAuthGuard] },
  { path: 'employeeProfile', component: EmployeeProfileComponent, canActivate: [AdminAuthGuard] },
  { path: 'paymentresponse', component: PaymentresponseComponent },
  { path: 'registerstaff', component: StaffRegistrationComponent, canActivate: [AdminAuthGuard] },
  { path: 'stafflist', component: StaffListComponent, canActivate: [AdminAuthGuard] },
  { path: 'staffprofile', component: StaffProfileComponent, canActivate: [AdminAuthGuard] },
  { path: 'doctorslots', component: EmployeeSlotsComponent, canActivate: [AdminAuthGuard] },
  { path: 'admindashboard', component: DeshboardComponent, canActivate: [AdminAuthGuard] },
  { path: 'termsAndConditions', component: TermsAndConditionsComponent },
  { path: 'privacyPolicy', component: PrivacyPolicyComponent },
  { path: 'faq', component: UserFaqComponent },
  { path: 'EditDoctor', component: EditEmployeeComponent, canActivate: [AdminAuthGuard] },
  { path: 'EditStaff', component: EditStaffComponent, canActivate: [AdminAuthGuard] },
  { path: 'coupon', component: CouponComponent, canActivate: [AdminAuthGuard] },
  { path: 'userCoupons', component: UserCouponsComponent, canActivate: [AdminAuthGuard] },
  {path: 'importCoupon', component: ImportCouponComponent, canActivate: [AdminAuthGuard] },
  { path: 'firstavaliableDoctors', component: FirstavailableDoctorsComponent, canActivate: [AdminAuthGuard] },
  { path: 'assignMenus', component: RoleAccessibilityComponent, canActivate: [AdminAuthGuard] },
  { path: 'openAppointment', component: DeeplinkComponent },
  { path: 'deepLink', component: DeeplinkComponent },
  { path: 'corporatePartner', component: CorporatePartnerComponent, canActivate: [AdminAuthGuard] },
  { path: 'productList', component: LaboratoryTestComponent, canActivate: [AdminAuthGuard] },
  { path: 'partnerProducts', component: PartnerProductComponent, canActivate: [AdminAuthGuard] },
  { path: 'partnerDashboard', component: PartnerDashboardComponent, canActivate: [PartnerAuthGuard] },
  { path: 'orders', component: PartnerOrdersComponent, canActivate: [PartnerAuthGuard] },
  { path: 'manageProduct', component: PartnerManageProductComponent, canActivate: [PartnerAuthGuard] },
  { path: 'partnerLogin', component: PartnerLoginComponent },
  { path: 'generate-report', component: GenerateReportComponent, canActivate: [AdminAuthGuard] },
  { path: 'add-firebase-messages', component: AddFirebaseMessagesComponent, canActivate: [AdminAuthGuard] },
  { path: 'sendFirebaseMessage', component: AssginMessagesComponent, canActivate: [AdminAuthGuard] },
  { path: 'order-response', component: ApiResponseComponent },
  {path: 'add-subscription', component: AddSubscriptionComponent, canActivate: [AdminAuthGuard] },
  {path: 'assign-subscription', component: AssignSubscriptionComponent, canActivate: [AdminAuthGuard] },
  {path: 'bookAppointment', component: BookAppointmentComponent, canActivate: [AdminAuthGuard] },
  {path: 'subscription' , component: SubscriptionComponent, canActivate: [AdminAuthGuard] },
  {path: 'editSubscription', component: EditsubscriptionComponent, canActivate: [AdminAuthGuard] },
  {path: 'SubscriptionProduct', component: SubscriptionProductComponent, canActivate: [AdminAuthGuard] },
  {path: 'uploadedOrder', component: UploadedOrderComponent, canActivate: [AdminAuthGuard] },

];

@NgModule({
  imports: [BrowserModule, FormsModule, HttpModule, HttpClientModule, RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AdminAuthGuard, PartnerAuthGuard]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts